import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * This list corresponds to the timezone list from Shopify
 * It is filtered, sorted, and the information is mainly taken from '@vvo/tzdb'
 * Some missing information was manually added
 * Note: According to IANA standard, UTC should be named 'Etc/UTC', but our backend handles 'UTC' name
 */
export const timezones = [
    {
        name: 'Etc/GMT+12',
        alternativeName: 'International Date Line West',
        abbreviation: 'GMT-12',
        rawFormat: '-12:00 International Date Line West',
        label: '(GMT-12:00) International Date Line West',
    },
    {
        name: 'Pacific/Midway',
        alternativeName: 'Samoa Time',
        abbreviation: 'SST',
        rawFormat: '-11:00 Samoa Time - Midway',
        label: '(GMT-11:00) Midway Island',
    },
    {
        name: 'Pacific/Pago_Pago',
        alternativeName: 'Samoa Time',
        abbreviation: 'SST',
        rawFormat: '-11:00 Samoa Time - Pago Pago',
        label: '(GMT-11:00) American Samoa',
    },
    {
        name: 'Pacific/Honolulu',
        alternativeName: 'Hawaii-Aleutian Time',
        abbreviation: 'HAST',
        rawFormat: '-10:00 Hawaii-Aleutian Time - Honolulu, East Honolulu, Pearl City, Makakilo / Kapolei / Honokai Hale',
        label: '(GMT-10:00) Hawaii',
    },
    {
        name: 'America/Juneau',
        alternativeName: 'Alaska Time',
        abbreviation: 'AKST',
        rawFormat: '-09:00 Alaska Time - Anchorage, Juneau, Fairbanks, Eagle River',
        label: '(GMT-09:00) Alaska',
    },
    {
        name: 'America/Los_Angeles',
        alternativeName: 'Pacific Time',
        abbreviation: 'PST',
        rawFormat: '-08:00 Pacific Time - Los Angeles, San Diego, San Jose, San Francisco',
        label: '(GMT-08:00) Pacific Time (US & Canada)',
    },
    {
        name: 'America/Tijuana',
        alternativeName: 'Pacific Time',
        abbreviation: 'PST',
        rawFormat: '-08:00 Pacific Time - Tijuana, Mexicali, Ensenada, Rosarito',
        label: '(GMT-08:00) Tijuana',
    },
    {
        name: 'America/Denver',
        alternativeName: 'Mountain Time',
        abbreviation: 'MST',
        rawFormat: '-07:00 Mountain Time - Denver, El Paso, Albuquerque, Colorado Springs',
        label: '(GMT-07:00) Mountain Time (US & Canada)',
    },
    {
        name: 'America/Mazatlan',
        alternativeName: 'Mexican Pacific Time',
        abbreviation: 'GMT-7',
        rawFormat: '-07:00 Mexican Pacific Time - Hermosillo, Culiacán, Ciudad Obregón, Mazatlán',
        label: '(GMT-07:00) Mazatlan',
    },
    {
        name: 'America/Phoenix',
        alternativeName: 'Mountain Time',
        abbreviation: 'MST',
        rawFormat: '-07:00 Mountain Time - Phoenix, Tucson, Mesa, Chandler',
        label: '(GMT-07:00) Arizona',
    },
    {
        name: 'America/Chicago',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Chicago, Houston, San Antonio, Dallas',
        label: '(GMT-06:00) Central Time (US & Canada)',
    },
    {
        name: 'America/Chihuahua',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Mexico City, Iztapalapa, León de los Aldama, Puebla',
        label: '(GMT-07:00) Chihuahua',
    },
    {
        name: 'America/Guatemala',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Guatemala City, Villa Nueva, Mixco, Cobán',
        label: '(GMT-06:00) Central America',
    },
    {
        name: 'America/Mexico_City',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Mexico City, Iztapalapa, León de los Aldama, Puebla',
        label: '(GMT-06:00) Guadalajara, Mexico City',
    },
    {
        name: 'America/Monterrey',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Mexico City, Iztapalapa, León de los Aldama, Puebla',
        label: '(GMT-06:00) Monterrey',
    },
    {
        name: 'America/Regina',
        alternativeName: 'Central Time',
        abbreviation: 'CST',
        rawFormat: '-06:00 Central Time - Saskatoon, Regina, Prince Albert, Moose Jaw',
        label: '(GMT-06:00) Saskatchewan',
    },
    {
        name: 'America/Bogota',
        alternativeName: 'Colombia Time',
        abbreviation: 'COT',
        rawFormat: '-05:00 Colombia Time - Bogotá, Cali, Medellín, Barranquilla',
        label: '(GMT-05:00) Bogota',
    },
    {
        name: 'America/Indiana/Indianapolis',
        alternativeName: 'Eastern Time',
        abbreviation: 'EST',
        rawFormat: '-05:00 Eastern Time - New York City, Brooklyn, Queens, Philadelphia',
        label: '(GMT-05:00) Indiana (East)',
    },
    {
        name: 'America/Lima',
        alternativeName: 'Peru Time',
        abbreviation: 'PET',
        rawFormat: '-05:00 Peru Time - Lima, Callao, Arequipa, Trujillo',
        label: '(GMT-05:00) Lima, Quito',
    },
    {
        name: 'America/New_York',
        alternativeName: 'Eastern Time',
        abbreviation: 'EST',
        rawFormat: '-05:00 Eastern Time - New York City, Brooklyn, Queens, Philadelphia',
        label: '(GMT-05:00) Eastern Time (US & Canada)',
    },
    {
        name: 'America/Caracas',
        alternativeName: 'Venezuela Time',
        abbreviation: 'VET',
        rawFormat: '-04:00 Venezuela Time - Caracas, Maracaibo, Maracay, Valencia',
        label: '(GMT-04:00) Caracas',
    },
    {
        name: 'America/Guyana',
        alternativeName: 'Guyana Time',
        abbreviation: 'GYT',
        rawFormat: '-04:00 Guyana Time - Georgetown, Linden, New Amsterdam',
        label: '(GMT-04:00) Georgetown',
    },
    {
        name: 'America/Halifax',
        alternativeName: 'Atlantic Time',
        abbreviation: 'AST',
        rawFormat: '-04:00 Atlantic Time - Halifax, Moncton, Sydney, Dartmouth',
        label: '(GMT-04:00) Atlantic Time (Canada)',
    },
    {
        name: 'America/La_Paz',
        alternativeName: 'Bolivia Time',
        abbreviation: 'BOT',
        rawFormat: '-04:00 Bolivia Time - La Paz, Santa Cruz de la Sierra, Cochabamba, Sucre',
        label: '(GMT-04:00) La Paz',
    },
    {
        name: 'America/Puerto_Rico',
        alternativeName: 'Atlantic Time',
        abbreviation: 'AST',
        rawFormat: '-04:00 Atlantic Time - San Juan, Bayamón, Carolina, Ponce',
        label: '(GMT-04:00) Puerto Rico',
    },
    {
        name: 'America/Santiago',
        alternativeName: 'Chile Time',
        abbreviation: 'CLT',
        rawFormat: '-04:00 Chile Time - Santiago, Puente Alto, Antofagasta, Viña del Mar',
        label: '(GMT-04:00) Santiago',
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        alternativeName: 'Argentina Time',
        abbreviation: 'ART',
        rawFormat: '-03:00 Argentina Time - Buenos Aires, Córdoba, Rosario, Mar del Plata',
        label: '(GMT-03:00) Buenos Aires',
    },
    {
        name: 'America/Montevideo',
        alternativeName: 'Uruguay Time',
        abbreviation: 'UYT',
        rawFormat: '-03:00 Uruguay Time - Montevideo, Salto, Paysandú, Las Piedras',
        label: '(GMT-03:00) Montevideo',
    },
    {
        name: 'America/Sao_Paulo',
        alternativeName: 'Brasilia Time',
        abbreviation: 'BRT',
        rawFormat: '-03:00 Brasilia Time - São Paulo, Rio de Janeiro, Belo Horizonte, Salvador',
        label: '(GMT-03:00) Brasilia',
    },
    {
        name: 'America/St_Johns',
        alternativeName: 'Newfoundland Time',
        abbreviation: 'NST',
        rawFormat: "-03:30 Newfoundland Time - St. John's, Mount Pearl, Corner Brook, Conception Bay South",
        label: '(GMT-03:30) Newfoundland',
    },
    {
        name: 'Atlantic/South_Georgia',
        alternativeName: 'South Georgia Time',
        abbreviation: 'GST',
        rawFormat: '-02:00 South Georgia Time - Grytviken',
        label: '(GMT-02:00) Mid-Atlantic',
    },
    {
        name: 'Atlantic/Azores',
        alternativeName: 'Azores Time',
        abbreviation: 'AZOT',
        rawFormat: '-01:00 Azores Time - Ponta Delgada',
        label: '(GMT-01:00) Azores',
    },
    {
        name: 'Atlantic/Cape_Verde',
        alternativeName: 'Cape Verde Time',
        abbreviation: 'CVT',
        rawFormat: '-01:00 Cape Verde Time - Praia, Mindelo, Espargos, Assomada',
        label: '(GMT-01:00) Cape Verde Is.',
    },
    {
        name: 'Africa/Monrovia',
        alternativeName: 'Greenwich Mean Time',
        abbreviation: 'GMT',
        rawFormat: '+00:00 Greenwich Mean Time - Monrovia, Gbarnga, Buchanan, Ganta',
        label: '(GMT+00:00) Monrovia',
    },
    {
        name: 'Europe/Dublin',
        alternativeName: 'Greenwich Mean Time',
        abbreviation: 'GMT',
        rawFormat: '+00:00 Greenwich Mean Time - Dublin, South Dublin, Cork, Limerick',
        label: '(GMT+00:00) Dublin',
    },
    {
        name: 'Europe/Lisbon',
        alternativeName: 'Western European Time',
        abbreviation: 'WET',
        rawFormat: '+00:00 Western European Time - Lisbon, Porto, Amadora, Braga',
        label: '(GMT+00:00) Lisbon',
    },
    {
        name: 'Europe/London',
        alternativeName: 'Greenwich Mean Time',
        abbreviation: 'GMT',
        rawFormat: '+00:00 Greenwich Mean Time - London, Birmingham, Liverpool, Glasgow',
        label: '(GMT+00:00) Edinburgh, London',
    },
    {
        name: 'UTC',
        alternativeName: 'Coordinated Universal Time',
        abbreviation: 'UTC',
        rawFormat: '+00:00 Coordinated Universal Time',
        label: '(GMT+00:00) UTC',
    },
    {
        name: 'Africa/Algiers',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Algiers, Oran, Constantine, Annaba',
        label: '(GMT+01:00) West Central Africa',
    },
    {
        name: 'Africa/Casablanca',
        alternativeName: 'Western European Time',
        abbreviation: 'WET',
        rawFormat: '+00:00 Western European Time - Casablanca, Rabat, Fes, Tangier',
        label: '(GMT+01:00) Casablanca',
    },
    {
        name: 'Europe/Amsterdam',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Amsterdam, Rotterdam, The Hague, Utrecht',
        label: '(GMT+01:00) Amsterdam',
    },
    {
        name: 'Europe/Belgrade',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Belgrade, Niš, Novi Sad, Zemun',
        label: '(GMT+01:00) Belgrade',
    },
    {
        name: 'Europe/Berlin',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Berlin, Hamburg, Munich, Köln',
        label: '(GMT+01:00) Berlin',
    },
    {
        name: 'Europe/Bratislava',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Bratislava, Košice, Nitra, Prešov',
        label: '(GMT+01:00) Bratislava',
    },
    {
        name: 'Europe/Brussels',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Brussels, Antwerpen, Gent, Charleroi',
        label: '(GMT+01:00) Brussels',
    },
    {
        name: 'Europe/Budapest',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Budapest, Debrecen, Szeged, Miskolc',
        label: '(GMT+01:00) Budapest',
    },
    {
        name: 'Europe/Copenhagen',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Copenhagen, Århus, Odense, Aalborg',
        label: '(GMT+01:00) Copenhagen',
    },
    {
        name: 'Europe/Ljubljana',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Ljubljana, Maribor, Kranj, Celje',
        label: '(GMT+01:00) Ljubljana',
    },
    {
        name: 'Europe/Madrid',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Madrid, Barcelona, Valencia, Sevilla',
        label: '(GMT+01:00) Madrid',
    },
    {
        name: 'Europe/Paris',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Paris, Marseille, Lyon, Toulouse',
        label: '(GMT+01:00) Paris',
    },
    {
        name: 'Europe/Prague',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Prague, Brno, Ostrava, Pilsen',
        label: '(GMT+01:00) Prague',
    },
    {
        name: 'Europe/Rome',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Rome, Milan, Naples, Turin',
        label: '(GMT+01:00) Rome',
    },
    {
        name: 'Europe/Sarajevo',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Sarajevo, Banja Luka, Zenica, Tuzla',
        label: '(GMT+01:00) Sarajevo',
    },
    {
        name: 'Europe/Skopje',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Skopje, Kumanovo, Prilep, Bitola',
        label: '(GMT+01:00) Skopje',
    },
    {
        name: 'Europe/Stockholm',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Stockholm, Göteborg, Malmö, Uppsala',
        label: '(GMT+01:00) Stockholm',
    },
    {
        name: 'Europe/Vienna',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Vienna, Graz, Linz, Favoriten',
        label: '(GMT+01:00) Vienna',
    },
    {
        name: 'Europe/Warsaw',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Warsaw, Łódź, Kraków, Wrocław',
        label: '(GMT+01:00) Warsaw',
    },
    {
        name: 'Europe/Zagreb',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Zagreb, Split, Rijeka, Osijek',
        label: '(GMT+01:00) Zagreb',
    },
    {
        name: 'Europe/Zurich',
        alternativeName: 'Central European Time',
        abbreviation: 'CET',
        rawFormat: '+01:00 Central European Time - Zürich, Genève, Basel, Lausanne',
        label: '(GMT+01:00) Bern, Zurich',
    },
    {
        name: 'Africa/Cairo',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Cairo, Alexandria, Giza, Shubrā al Khaymah',
        label: '(GMT+02:00) Cairo',
    },
    {
        name: 'Africa/Harare',
        alternativeName: 'Central Africa Time',
        abbreviation: 'CAT',
        rawFormat: '+02:00 Central Africa Time - Harare, Bulawayo, Chitungwiza, Mutare',
        label: '(GMT+02:00) Harare',
    },
    {
        name: 'Africa/Johannesburg',
        alternativeName: 'South Africa Time',
        abbreviation: 'SAST',
        rawFormat: '+02:00 South Africa Time - Johannesburg, Cape Town, Durban, Pretoria',
        label: '(GMT+02:00) Pretoria',
    },
    {
        name: 'Asia/Jerusalem',
        alternativeName: 'Israel Time',
        abbreviation: 'IST',
        rawFormat: '+02:00 Israel Time - Jerusalem, Tel Aviv, West Jerusalem, Haifa',
        label: '(GMT+02:00) Jerusalem',
    },
    {
        name: 'Europe/Athens',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Athens, Thessaloníki, Pátra, Piraeus',
        label: '(GMT+02:00) Athens',
    },
    {
        name: 'Europe/Bucharest',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Bucharest, Sector 3, Iaşi, Sector 6',
        label: '(GMT+02:00) Bucharest',
    },
    {
        name: 'Europe/Helsinki',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Helsinki, Espoo, Tampere, Oulu',
        label: '(GMT+02:00) Helsinki',
    },
    {
        name: 'Europe/Kaliningrad',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk',
        label: '(GMT+02:00) Kaliningrad',
    },
    {
        name: 'Europe/Riga',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Riga, Daugavpils, Liepāja, Jelgava',
        label: '(GMT+02:00) Riga',
    },
    {
        name: 'Europe/Sofia',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Sofia, Plovdiv, Varna, Burgas',
        label: '(GMT+02:00) Sofia',
    },
    {
        name: 'Europe/Tallinn',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Tallinn, Tartu, Narva, Pärnu',
        label: '(GMT+02:00) Tallinn',
    },
    {
        name: 'Europe/Vilnius',
        alternativeName: 'Eastern European Time',
        abbreviation: 'EET',
        rawFormat: '+02:00 Eastern European Time - Vilnius, Kaunas, Klaipėda, Šiauliai',
        label: '(GMT+02:00) Vilnius',
    },
    {
        name: 'Africa/Nairobi',
        alternativeName: 'East Africa Time',
        abbreviation: 'EAT',
        rawFormat: '+03:00 East Africa Time - Nairobi, Kakamega, Mombasa, Nakuru',
        label: '(GMT+03:00) Nairobi',
    },
    {
        name: 'Asia/Baghdad',
        alternativeName: 'Arabian Time',
        abbreviation: 'AST',
        rawFormat: '+03:00 Arabian Time - Baghdad, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul',
        label: '(GMT+03:00) Baghdad',
    },
    {
        name: 'Asia/Kuwait',
        alternativeName: 'Arabian Time',
        abbreviation: 'AST',
        rawFormat: '+03:00 Arabian Time - Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim',
        label: '(GMT+03:00) Kuwait',
    },
    {
        name: 'Asia/Riyadh',
        alternativeName: 'Arabian Time',
        abbreviation: 'AST',
        rawFormat: '+03:00 Arabian Time - Jeddah, Riyadh, Makkah, Madinah',
        label: '(GMT+03:00) Riyadh',
    },
    {
        name: 'Europe/Istanbul',
        alternativeName: 'Turkey Time',
        abbreviation: 'TRT',
        rawFormat: '+03:00 Turkey Time - Istanbul, Ankara, Bursa, İzmir',
        label: '(GMT+03:00) Istanbul',
    },
    {
        name: 'Europe/Minsk',
        alternativeName: 'Moscow Time',
        abbreviation: 'MSK',
        rawFormat: "+03:00 Moscow Time - Minsk, Homyel', Hrodna, Vitebsk",
        label: '(GMT+03:00) Minsk',
    },
    {
        name: 'Europe/Moscow',
        alternativeName: 'Moscow Time',
        abbreviation: 'MSK',
        rawFormat: '+03:00 Moscow Time - Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan',
        label: '(GMT+03:00) Moscow, St. Petersburg',
    },
    {
        name: 'Europe/Volgograd',
        alternativeName: 'Volgograd Time',
        abbreviation: 'VOLT',
        rawFormat: '+03:00 Volgograd Time - Volgograd, Volzhsky, Kamyshin, Mikhaylovka',
        label: '(GMT+03:00) Volgograd',
    },
    {
        name: 'Asia/Tehran',
        alternativeName: 'Iran Time',
        abbreviation: 'IRST',
        rawFormat: '+03:30 Iran Time - Tehran, Mashhad, Isfahan, Karaj',
        label: '(GMT+03:30) Tehran',
    },
    {
        name: 'Asia/Baku',
        alternativeName: 'Azerbaijan Time',
        abbreviation: 'AZT',
        rawFormat: '+04:00 Azerbaijan Time - Baku, Sumqayıt, Ganja, Lankaran',
        label: '(GMT+04:00) Baku',
    },
    {
        name: 'Asia/Muscat',
        alternativeName: 'Gulf Time',
        abbreviation: 'GST',
        rawFormat: "+04:00 Gulf Time - Muscat, Seeb, Bawshar, 'Ibrī",
        label: '(GMT+04:00) Abu Dhabi, Muscat',
    },
    {
        name: 'Asia/Tbilisi',
        alternativeName: 'Georgia Time',
        abbreviation: 'GET',
        rawFormat: '+04:00 Georgia Time - Tbilisi, Batumi, Kutaisi, Rustavi',
        label: '(GMT+04:00) Tbilisi',
    },
    {
        name: 'Asia/Yerevan',
        alternativeName: 'Armenia Time',
        abbreviation: 'AMT',
        rawFormat: '+04:00 Armenia Time - Yerevan, Malatia-Sebastia, Shengavit, Nor Nork',
        label: '(GMT+04:00) Yerevan',
    },
    {
        name: 'Europe/Samara',
        alternativeName: 'Samara Time',
        abbreviation: 'SAMT',
        rawFormat: '+04:00 Samara Time - Samara, Saratov, Tolyatti, Izhevsk',
        label: '(GMT+04:00) Samara',
    },
    {
        name: 'Asia/Kabul',
        alternativeName: 'Afghanistan Time',
        abbreviation: 'AFT',
        rawFormat: '+04:30 Afghanistan Time - Kabul, Herāt, Mazār-e Sharīf, Kandahār',
        label: '(GMT+04:30) Kabul',
    },
    {
        name: 'Asia/Almaty',
        alternativeName: 'West Kazakhstan Time',
        abbreviation: 'AQTT',
        rawFormat: '+05:00 West Kazakhstan Time - Almaty, Shymkent, Aktobe, Karagandy',
        label: '(GMT+06:00) Almaty',
    },
    {
        name: 'Asia/Karachi',
        alternativeName: 'Pakistan Time',
        abbreviation: 'PKT',
        rawFormat: '+05:00 Pakistan Time - Lahore, Karachi, Peshawar, Faisalabad',
        label: '(GMT+05:00) Islamabad, Karachi',
    },
    {
        name: 'Asia/Tashkent',
        alternativeName: 'Uzbekistan Time',
        abbreviation: 'UZT',
        rawFormat: '+05:00 Uzbekistan Time - Tashkent, Namangan, Samarkand, Andijon',
        label: '(GMT+05:00) Tashkent',
    },
    {
        name: 'Asia/Yekaterinburg',
        alternativeName: 'Yekaterinburg Time',
        abbreviation: 'YEKT',
        rawFormat: '+05:00 Yekaterinburg Time - Yekaterinburg, Chelyabinsk, Ufa, Perm',
        label: '(GMT+05:00) Ekaterinburg',
    },
    {
        name: 'Asia/Colombo',
        alternativeName: 'India Time',
        abbreviation: 'IST',
        rawFormat: '+05:30 India Time - Colombo, Dehiwala-Mount Lavinia, Maharagama, Jaffna',
        label: '(GMT+05:30) Sri Jayawardenepura',
    },
    {
        name: 'Asia/Kolkata',
        alternativeName: 'India Time',
        abbreviation: 'IST',
        rawFormat: '+05:30 India Time - Mumbai, Delhi, Bengaluru, Hyderābād',
        label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    },
    {
        name: 'Asia/Kathmandu',
        alternativeName: 'Nepal Time',
        abbreviation: 'NPT',
        rawFormat: '+05:45 Nepal Time - Kathmandu, Bharatpur, Pātan, Birgañj',
        label: '(GMT+05:45) Kathmandu',
    },
    {
        name: 'Asia/Dhaka',
        alternativeName: 'Bangladesh Time',
        abbreviation: 'BST',
        rawFormat: '+06:00 Bangladesh Time - Dhaka, Chattogram, Gazipur, Khulna',
        label: '(GMT+06:00) Astana, Dhaka',
    },
    {
        name: 'Asia/Urumqi',
        alternativeName: 'China Time',
        abbreviation: 'CST',
        rawFormat: '+06:00 China Time - Ürümqi, Shihezi, Korla, Aqsu',
        label: '(GMT+06:00) Urumqi',
    },
    {
        name: 'Asia/Bangkok',
        alternativeName: 'Indochina Time',
        abbreviation: 'ICT',
        rawFormat: '+07:00 Indochina Time - Bangkok, Samut Prakan, Mueang Nonthaburi, Chon Buri',
        label: '(GMT+07:00) Bangkok, Hanoi',
    },
    {
        name: 'Asia/Jakarta',
        alternativeName: 'Western Indonesia Time',
        abbreviation: 'WIB',
        rawFormat: '+07:00 Western Indonesia Time - Jakarta, Surabaya, Bekasi, Bandung',
        label: '(GMT+07:00) Jakarta',
    },
    {
        name: 'Asia/Krasnoyarsk',
        alternativeName: 'Krasnoyarsk Time',
        abbreviation: 'KRAT',
        rawFormat: '+07:00 Krasnoyarsk Time - Krasnoyarsk, Abakan, Norilsk, Achinsk',
        label: '(GMT+07:00) Krasnoyarsk',
    },
    {
        name: 'Asia/Novosibirsk',
        alternativeName: 'Novosibirsk Time',
        abbreviation: 'NOVT',
        rawFormat: '+07:00 Novosibirsk Time - Novosibirsk, Krasnoyarsk, Barnaul, Tomsk',
        label: '(GMT+07:00) Novosibirsk',
    },
    {
        name: 'Asia/Chongqing',
        alternativeName: 'China Time',
        abbreviation: 'CST',
        rawFormat: '+08:00 China Time - Chongqing, Chengdu, Nanchong, Mianyang',
        label: '(GMT+08:00) Chongqing',
    },
    {
        name: 'Asia/Hong_Kong',
        alternativeName: 'Hong Kong Time',
        abbreviation: 'HKT',
        rawFormat: '+08:00 Hong Kong Time - Hong Kong, New Territories, Kowloon, Hong Kong Island',
        label: '(GMT+08:00) Hong Kong',
    },
    {
        name: 'Asia/Irkutsk',
        alternativeName: 'Irkutsk Time',
        abbreviation: 'IRKT',
        rawFormat: '+08:00 Irkutsk Time - Irkutsk, Ulan-Ude, Bratsk, Angarsk',
        label: '(GMT+08:00) Irkutsk',
    },
    {
        name: 'Asia/Kuala_Lumpur',
        alternativeName: 'Malaysia Time',
        abbreviation: 'MYT',
        rawFormat: '+08:00 Malaysia Time - Kuala Lumpur, Petaling Jaya, Klang, Johor Bahru',
        label: '(GMT+08:00) Kuala Lumpur',
    },
    {
        name: 'Asia/Shanghai',
        alternativeName: 'China Time',
        abbreviation: 'CST',
        rawFormat: '+08:00 China Time - Shanghai, Beijing, Shenzhen, Guangzhou',
        label: '(GMT+08:00) Beijing',
    },
    {
        name: 'Asia/Singapore',
        alternativeName: 'Singapore Time',
        abbreviation: 'SGT',
        rawFormat: '+08:00 Singapore Time - Singapore, Ulu Bedok, Bedok New Town, Tampines Estate',
        label: '(GMT+08:00) Singapore',
    },
    {
        name: 'Asia/Taipei',
        alternativeName: 'Taipei Time',
        abbreviation: 'TWT',
        rawFormat: '+08:00 Taipei Time - Taipei, New Taipei City, Kaohsiung, Taichung',
        label: '(GMT+08:00) Taipei',
    },
    {
        name: 'Asia/Ulaanbaatar',
        alternativeName: 'Ulaanbaatar Time',
        abbreviation: 'ULAT',
        rawFormat: '+08:00 Ulaanbaatar Time - Ulan Bator, Erdenet, Darhan, Mörön',
        label: '(GMT+08:00) Ulaanbaatar',
    },
    {
        name: 'Australia/Perth',
        alternativeName: 'Australian Western Time',
        abbreviation: 'AWST',
        rawFormat: '+08:00 Australian Western Time - Perth, Mandurah, Bunbury, Baldivis',
        label: '(GMT+08:00) Perth',
    },
    {
        name: 'Asia/Seoul',
        alternativeName: 'Korean Time',
        abbreviation: 'KST',
        rawFormat: '+09:00 Korean Time - Seoul, Busan, Incheon, Daegu',
        label: '(GMT+09:00) Seoul',
    },
    {
        name: 'Asia/Tokyo',
        alternativeName: 'Japan Time',
        abbreviation: 'JST',
        rawFormat: '+09:00 Japan Time - Tokyo, Yokohama, Osaka, Nagoya',
        label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
    },
    {
        name: 'Asia/Yakutsk',
        alternativeName: 'Yakutsk Time',
        abbreviation: 'YAKT',
        rawFormat: '+09:00 Yakutsk Time - Yakutsk, Blagoveshchensk, Belogorsk, Neryungri',
        label: '(GMT+09:00) Yakutsk',
    },
    {
        name: 'Australia/Adelaide',
        alternativeName: 'Australian Central Time',
        abbreviation: 'ACST',
        rawFormat: '+09:30 Australian Central Time - Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale',
        label: '(GMT+09:30) Adelaide',
    },
    {
        name: 'Australia/Darwin',
        alternativeName: 'Australian Central Time',
        abbreviation: 'ACST',
        rawFormat: '+09:30 Australian Central Time - Darwin, Alice Springs, Palmerston',
        label: '(GMT+09:30) Darwin',
    },
    {
        name: 'Australia/Brisbane',
        alternativeName: 'Australian Eastern Time',
        abbreviation: 'AEST',
        rawFormat: '+10:00 Australian Eastern Time - Brisbane, Gold Coast, Logan City, Townsville',
        label: '(GMT+10:00) Brisbane',
    },
    {
        name: 'Australia/Hobart',
        alternativeName: 'Australian Eastern Time',
        abbreviation: 'AEST',
        rawFormat: '+10:00 Australian Eastern Time - Hobart, Launceston, Devonport, Burnie',
        label: '(GMT+10:00) Hobart',
    },
    {
        name: 'Australia/Melbourne',
        alternativeName: 'Australian Eastern Time',
        abbreviation: 'AEST',
        rawFormat: '+10:00 Australian Eastern Time - Melbourne, Sydney, Brisbane, Canberra',
        label: '(GMT+10:00) Canberra, Melbourne',
    },
    {
        name: 'Australia/Sydney',
        alternativeName: 'Australian Eastern Time',
        abbreviation: 'AEST',
        rawFormat: '+10:00 Australian Eastern Time - Sydney, Melbourne, Canberra, Newcastle',
        label: '(GMT+10:00) Sydney',
    },
    {
        name: 'Asia/Vladivostok',
        alternativeName: 'Vladivostok Time',
        abbreviation: 'VLAT',
        rawFormat: '+10:00 Vladivostok Time - Khabarovsk, Vladivostok, Khabarovsk Vtoroy, Komsomolsk-on-Amur',
        label: '(GMT+10:00) Vladivostok',
    },
    {
        name: 'Pacific/Guam',
        alternativeName: 'Chamorro Time',
        abbreviation: 'ChST',
        rawFormat: '+10:00 Chamorro Time - Dededo Village, Yigo Village, Tamuning-Tumon-Harmon Village, Tamuning',
        label: '(GMT+10:00) Guam',
    },
    {
        name: 'Pacific/Port_Moresby',
        alternativeName: 'Papua New Guinea Time',
        abbreviation: 'PGT',
        rawFormat: '+10:00 Papua New Guinea Time - Port Moresby, Lae, Mount Hagen, Popondetta',
        label: '(GMT+10:00) Port Moresby',
    },
    {
        name: 'Asia/Magadan',
        alternativeName: 'Magadan Time',
        abbreviation: 'MAGT',
        rawFormat: '+11:00 Magadan Time - Magadan, Ust-Nera, Susuman, Ola',
        label: '(GMT+11:00) Magadan',
    },
    {
        name: 'Asia/Srednekolymsk',
        alternativeName: 'Srednekolymsk Time',
        abbreviation: 'SRET',
        rawFormat: '+11:00 Srednekolymsk Time - Srednekolymsk, Zyryanka, Chersky',
        label: '(GMT+11:00) Srednekolymsk',
    },
    {
        name: 'Pacific/Guadalcanal',
        alternativeName: 'Solomon Islands Time',
        abbreviation: 'SBT',
        rawFormat: '+11:00 Solomon Islands Time - Honiara',
        label: '(GMT+11:00) Solomon Is.',
    },
    {
        name: 'Pacific/Noumea',
        alternativeName: 'New Caledonia Time',
        abbreviation: 'NCT',
        rawFormat: '+11:00 New Caledonia Time - Nouméa, Mont-Dore, Dumbéa',
        label: '(GMT+11:00) New Caledonia',
    },
    {
        name: 'Asia/Kamchatka',
        alternativeName: 'Petropavlovsk-Kamchatski Time',
        abbreviation: 'PETT',
        rawFormat: '+12:00 Petropavlovsk-Kamchatski Time - Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Anadyr',
        label: '(GMT+12:00) Kamchatka',
    },
    {
        name: 'Pacific/Auckland',
        alternativeName: 'New Zealand Time',
        abbreviation: 'NZST',
        rawFormat: '+12:00 New Zealand Time - Auckland, Christchurch, Wellington, Manukau City',
        label: '(GMT+12:00) Auckland, Wellington',
    },
    {
        name: 'Pacific/Fiji',
        alternativeName: 'Fiji Time',
        abbreviation: 'FJT',
        rawFormat: '+12:00 Fiji Time - Nasinu, Suva, Lautoka, Nadi',
        label: '(GMT+12:00) Fiji',
    },
    {
        name: 'Pacific/Majuro',
        alternativeName: 'Marshall Islands Time',
        abbreviation: 'MHT',
        rawFormat: '+12:00 Marshall Islands Time - Majuro, Kwajalein, RMI Capitol',
        label: '(GMT+12:00) Marshall Is.',
    },
    {
        name: 'Pacific/Chatham',
        alternativeName: 'Chatham Time',
        abbreviation: 'CHAST',
        rawFormat: '+12:45 Chatham Time - Chatham',
        label: '(GMT+12:45) Chatham Is.',
    },
    {
        name: 'Pacific/Apia',
        alternativeName: 'Apia Time',
        abbreviation: 'WST',
        rawFormat: '+13:00 Apia Time - Apia',
        label: '(GMT+13:00) Samoa',
    },
    {
        name: 'Pacific/Fakaofo',
        alternativeName: 'Tokelau Time',
        abbreviation: 'TKT',
        rawFormat: '+13:00 Tokelau Time - Fakaofo',
        label: '(GMT+13:00) Tokelau Is.',
    },
    {
        name: 'Pacific/Tongatapu',
        alternativeName: 'Tonga Time',
        abbreviation: 'TOT',
        rawFormat: "+13:00 Tonga Time - Nuku'alofa",
        label: "(GMT+13:00) Nuku'alofa",
    },
];
export const getTimezone = (name) => {
    const timezoneName = name || Intl.DateTimeFormat().resolvedOptions().timeZone;
    // First search in the static timezones list
    const staticTimeZone = timezones.find(({ name }) => name === timezoneName);
    if (staticTimeZone) {
        return staticTimeZone;
    }
    // Handle Etc/GMT+X format
    const etcGmtMatch = timezoneName.match(/^Etc\/GMT([+-]\d+)$/);
    if (etcGmtMatch) {
        const offset = parseInt(etcGmtMatch[1]);
        // Find timezone with matching offset
        const matchingTimezone = timezones.find(({ rawFormat }) => {
            const formatOffset = parseInt(rawFormat.split(' ')[0]);
            return formatOffset === offset;
        });
        if (matchingTimezone) {
            return matchingTimezone;
        }
    }
    // Return UTC as fallback
    return getTimezone('UTC');
};
export const getTimezoneAbbreviation = (timezone) => getTimezone(timezone).abbreviation;
export const parseUTCToLocal = (date, timezone) => dayjs.utc(date).tz(timezone);
export const formatDateInTimezone = (date, timezone, format = 'YYYY-MM-DD HH:mm') => dayjs(date).tz(timezone).format(format);
export const formatUTCWithTimezoneOffset = (date, timezone, format = 'YYYY-MM-DDTHH:mm:ssZ') => {
    const dateObj = dayjs.utc(date);
    const offset = dayjs.tz(dateObj, timezone).format('Z');
    if (offset === '+00:00') {
        return dateObj.format(format).replace('+00:00', 'Z');
    }
    return dateObj.format(format.replace('Z', offset));
};
export const convertLocalToUTC = (date, timezone) => dayjs(date).tz(timezone, true).utc().toISOString();
export const toDayjs = (date) => {
    return typeof date === 'string' || date instanceof Date ? dayjs(date) : date;
};
export const removeTimezoneOffset = (date) => {
    return date.replace(/[+-]\d{2}:\d{2}$/, 'Z');
};
export const convertLocalDateToTimezonedTimestamp = (date, timezone) => {
    return dayjs(date).tz(timezone, true).utc().valueOf();
};
export const convertTimezonedTimestampToLocalDate = (timestamp, timezone) => dayjs.utc(timestamp).tz(timezone).tz(undefined, true).toDate();
export const convertToLocalDate = (date, timezone) => dayjs.utc(date).tz(timezone).tz(undefined, true).toDate();
